import { render } from "./PrivateSalesIndex.vue?vue&type=template&id=615d524f"
import script from "./PrivateSalesIndex.vue?vue&type=script&lang=js"
export * from "./PrivateSalesIndex.vue?vue&type=script&lang=js"

import "./PrivateSalesIndex.vue?vue&type=style&index=0&id=615d524f&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__